import { Image, StyleSheet, Text, View, ScrollView } from "react-native";
import React, { useState } from "react";
import InputText from "../../../../components/InputText";
import { Button, useTheme } from "react-native-paper";
import { LoginScreenProps } from "../AuthStack";
import useApi from "../../../../hooks/useAPI";
import { showMessage } from "react-native-flash-message";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {
	REFRESH_TOKEN_STORAGE_KEY,
	TOKEN_STORAGE_KEY,
} from "../../../../store/api";
import {
	ACTIVE_USER_ID,
	AuthState,
	login,
	ALL_USER_INFO,
} from "../../../../store/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import LinearLoading from "../../../../components/LinearLoading";
import { SafeAreaView } from "react-native-safe-area-context";
import { getPrimaryColor } from "../../../../utils/ColorsFunctions";
import { useForm, Controller } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import logInSchema from "../../../../schemas/logInSchema";
// import * as Device from "expo-device";
// import * as Notifications from "expo-notifications";

const logoBanner = require("../../../../../assets/images/onBoarding/logoisicinternational.png");

type inputsData = {
	email: string;
	password: string;
};

const LoginScreen = ({ navigation }: LoginScreenProps) => {
	const [loading, setLoading] = useState(false);
	const api = useApi();
	const dispatch = useAppDispatch();
	const user = useAppSelector(s => s.auth.subUser!);
	// const [expoPushToken, setExpoPushToken] = useState("");
	// const [notification, setNotification] = useState(false);
	// const notificationListener = useRef();
	// const responseListener = useRef();
	// const [showError, setShowError] = useState(false);
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<inputsData>({
		resolver: joiResolver(logInSchema),
	});

	// Notifications.setNotificationHandler({
	// 	handleNotification: async () => ({
	// 		shouldShowAlert: true,
	// 		shouldPlaySound: true,
	// 		shouldSetBadge: true,
	// 	}),
	// });

	// async function registerForPushNotificationsAsync() {
	// 	let token;
	// 	if (Device.isDevice) {
	// 		const { status: existingStatus } =
	// 			await Notifications.getPermissionsAsync();
	// 		let finalStatus = existingStatus;
	// 		if (existingStatus !== "granted") {
	// 			const { status } = await Notifications.requestPermissionsAsync();
	// 			finalStatus = status;
	// 		}
	// 		if (finalStatus !== "granted") {
	// 			alert("Failed to get push token for push notification!");
	// 			return;
	// 		}
	// 		token = (await Notifications.getExpoPushTokenAsync()).data;
	// 	} else {
	// 		alert("Must use physical device for Push Notifications");
	// 	}

	// 	if (Platform.OS === "android") {
	// 		Notifications.setNotificationChannelAsync("default", {
	// 			name: "default",
	// 			importance: Notifications.AndroidImportance.MAX,
	// 			vibrationPattern: [0, 250, 250, 250],
	// 			lightColor: "#FF231F7C",
	// 		});
	// 	}

	// 	return token;
	// }

	const onSubmit = async (dataOfInputs: inputsData) => {
		setLoading(true);

		try {
			const { data: userData } = await api.firstAccess.login(
				dataOfInputs.email,
				dataOfInputs.password
			);
			await AsyncStorage.setItem(TOKEN_STORAGE_KEY, userData.token);
			await AsyncStorage.setItem(
				REFRESH_TOKEN_STORAGE_KEY,
				userData.refresh_token
			);
			await AsyncStorage.setItem(ACTIVE_USER_ID, dataOfInputs.email);
			await AsyncStorage.setItem(ALL_USER_INFO, JSON.stringify(userData));

			let loggedUser: AuthState = {
				email: dataOfInputs.email,
				userInfo: userData.user_info,
				token: userData.token,
				refreshToken: userData.refresh_token,
				auth: true,
			};
			showMessage({ type: "success", message: "Login bem-sucedido." });

			// registerForPushNotificationsAsync().then(async token => {
			// 	console.log({ token });
			// 	setExpoPushToken(token);
			// 	const { data } = await api.firstAccess.saveNotificationToken(
			// 		token,
			// 		userData.user_info.id
			// 	);

			// 	console.log({ data });
			// });

			if (
				userData.user_info.aggregate_users.length === 1 &&
				(userData.user_info.account_type === "student" ||
					userData.user_info.account_type === "Estudante")
			) {
				dispatch(
					login({
						...loggedUser,
						subUser: userData.user_info.aggregate_users[0],
					})
				);
			} else {
				dispatch(login(loggedUser));
				navigation.navigate("ChooseSubUser");
			}
		} catch (e: any) {
			showMessage({ type: "danger", message: "Login falhou." });
		} finally {
			setLoading(false);
		}
	};
	const { colors } = useTheme();
	// useEffect(() => {
	// 	// registerForPushNotificationsAsync().then(token => setExpoPushToken(token));

	// 	notificationListener.current =
	// 		Notifications.addNotificationReceivedListener(notification => {
	// 			setNotification(notification);
	// 		});

	// 	responseListener.current =
	// 		Notifications.addNotificationResponseReceivedListener(response => {
	// 			console.log(response);
	// 		});

	// 	return () => {
	// 		Notifications.removeNotificationSubscription(
	// 			notificationListener.current
	// 		);
	// 		Notifications.removeNotificationSubscription(responseListener.current);
	// 	};
	// }, []);

	return (
		<SafeAreaView style={styles.root}>
			<ScrollView contentContainerStyle={styles.container}>
				<Image source={logoBanner} style={styles.banner} resizeMode="contain" />
				<Text style={styles.header}>Bem-vindo(a) {"\n"} de volta!</Text>

				<Controller
					control={control}
					rules={{
						required: true,
					}}
					render={({ field: { onChange, onBlur, value } }) => (
						<InputText
							placeholder="Digite seu e-mail"
							style={[
								styles.inputs,
								{
									borderColor: errors.email
										? colors.error
										: colors.inputBackgroundColor,
								},
							]}
							onBlur={onBlur}
							onChange={onChange}
							value={value}
							selectionColor={colors.primary}
							textColor={errors.email ? colors.error : colors.text}
							placeholderTextColor={errors.email ? colors.error : colors.text}
							disabled={loading}
						/>
					)}
					name="email"
				/>

				<Controller
					control={control}
					rules={{
						required: true,
					}}
					render={({ field: { onChange, onBlur, value } }) => (
						<InputText
							placeholder="Digite sua senha"
							secureTextEntry={true}
							style={[
								styles.inputs,
								{
									borderColor: errors.password
										? colors.error
										: colors.inputBackgroundColor,
								},
							]}
							onBlur={onBlur}
							onChange={onChange}
							value={value}
							selectionColor={colors.primary}
							textColor={errors.password ? colors.error : colors.text}
							placeholderTextColor={
								errors.password ? colors.error : colors.text
							}
							disabled={loading}
						/>
					)}
					name="password"
				/>
				<Button
					style={styles.forgotPassword}
					onPress={() => navigation.navigate("ForgotPassword")}
				>
					Esqueceu sua senha?
				</Button>
				<Button
					style={styles.btn}
					labelStyle={styles.btnText}
					mode="contained"
					onPress={handleSubmit(onSubmit)}
					disabled={loading}
				>
					Entrar
				</Button>
				{loading ? <LinearLoading /> : <View style={styles.emptyLoader} />}
				<View></View>
				<View style={styles.footer}>
					<Text style={styles.text}>
						Não possui uma carteirinha ISIC?{" "}
						<Text
							style={[styles.linkText, { color: getPrimaryColor(user) }]}
							onPress={() => {
								navigation.navigate("NewUserStack", {
									screen: "CreateAccount",
								});
							}}
						>
							Clique aqui
						</Text>
					</Text>
				</View>
			</ScrollView>
		</SafeAreaView>
	);
};

export default LoginScreen;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		backgroundColor: "#fff",
	},
	container: {
		alignItems: "center",
	},
	banner: {
		width: 148,
		height: 63,
		marginBottom: 30,
	},
	header: {
		textAlign: "center",
		fontWeight: "600",
		fontSize: 32,
		marginBottom: 50,
	},
	inputs: {
		marginTop: 16,
		width: "90%",
		zIndex: 0,
		borderWidth: 1,
	},
	emailInput: {
		marginTop: 20,
		marginBottom: 12,
	},
	forgotPassword: {
		alignSelf: "flex-end",
		marginHorizontal: "5%",
	},
	btn: {
		marginTop: 20,
		marginBottom: 10,
		borderRadius: 25,
		height: 50,
	},
	btnText: {
		color: "#fff",
		fontSize: 15,
		lineHeight: 30,
		width: "80%",
	},
	footer: {
		marginTop: 20,
	},
	text: {
		textAlign: "center",
		color: "#999999",
	},
	linkText: { fontWeight: "700", textDecorationLine: "underline" },
	emptyLoader: {
		height: 4,
	},
});
